import React from "react";
import { useNavigate } from "react-router-dom";
import { COLORS } from "../../../helper/colors";
import {
  CloseIcon,
  HelpIcon,
  HomeIcon,
  KeyIcon,
  Loader,
  LogoutIcon,
  ProfileIcon,
} from "../../../icons";

export const Drawer = ({
  isOpen,
  setIsOpen,
  pathname,
  logoutWithRedirect,
  handleChangePassword,
  isChangePasswordLoading,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={
        " fixed overflow-hidden z-20 bg-gray-900 bg-opacity-25 inset-0 transform ease-in-out " +
        (isOpen
          ? " transition-opacity opacity-100 duration-500 translate-x-0"
          : " transition-all delay-500 opacity-0 translate-x-full")
      }
    >
      <div
        className={
          " w-screen max-w-lg right-0 absolute bg-primary h-full shadow-xl delay-400 duration-500 ease-in-out transition-all transform  " +
          (isOpen ? " translate-x-0 " : " translate-x-full ")
        }
      >
        <div className="p-4 relative w-screen max-w-lg pb-10 flex flex-col space-y-6 overflow-y-scroll h-full">
          <div className="flex w-full justify-between items-center">
            <div className="font-bold text-2xl text-white">Menu</div>
            <div
              className="font-bold text-lg text-textGray"
              role="button"
              onClick={() => setIsOpen(false)}
            >
              <CloseIcon fill={COLORS.white} height={14} width={14} />
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div
              className="flex w-full flex-row items-center text-xl font-bold my-2 cursor-pointer"
              onClick={() => {
                navigate("/home");
                setIsOpen(false);
              }}
            >
              <HomeIcon
                height={32}
                width={32}
                fill={pathname === "/home" ? COLORS.textGray : COLORS.white}
                className="cursor-pointer  mr-4"
              />
              <div
                className={
                  pathname === "/home" ? "text-textGray" : "text-white"
                }
              >
                Home
              </div>
            </div>
            <div
              className="flex w-full flex-row items-center text-xl font-bold my-2 cursor-pointer"
              onClick={() => {
                navigate("/help");
                setIsOpen(false);
              }}
            >
              <HelpIcon
                height={32}
                width={32}
                stroke={pathname === "/help" ? COLORS.textGray : COLORS.white}
                className="cursor-pointer  mr-4"
              />
              <div
                className={
                  pathname === "/help" ? "text-textGray" : "text-white"
                }
              >
                Help
              </div>
            </div>
            <div
              className="flex w-full flex-row items-center text-xl font-bold my-2 cursor-pointer"
              onClick={() => {
                navigate("/profile");
                setIsOpen(false);
              }}
            >
              <ProfileIcon
                height={32}
                width={32}
                stroke={
                  pathname === "/profile" ? COLORS.textGray : COLORS.white
                }
                fill={pathname === "/profile" ? COLORS.textGray : COLORS.white}
                className="cursor-pointer  mr-4"
              />
              <div
                className={
                  pathname === "/profile" ? "text-textGray" : "text-white"
                }
              >
                My Profile
              </div>
            </div>
            <div
              className="flex w-full flex-row items-center text-xl font-bold my-2 cursor-pointer"
              onClick={async () => {
                if (!isChangePasswordLoading) {
                  await handleChangePassword();
                  setIsOpen(false);
                }
              }}
            >
              <KeyIcon
                height={32}
                width={32}
                stroke={
                  pathname === "/change-password"
                    ? COLORS.textGray
                    : COLORS.white
                }
                fill={COLORS.primary}
                className="cursor-pointer  mr-4"
              />

              <div
                className={
                  pathname === "/change-password"
                    ? "text-textGray"
                    : "text-white"
                }
              >
                {!isChangePasswordLoading ? (
                  "Change Password"
                ) : (
                  <Loader height={20} width={20} fill="#fff" />
                )}{" "}
              </div>
            </div>
            <div
              className="flex w-full flex-row items-center text-xl font-bold my-2 cursor-pointer"
              onClick={logoutWithRedirect}
            >
              <LogoutIcon
                height={32}
                width={32}
                fill={COLORS.white}
                className="cursor-pointer  mr-4"
              />
              <div className="text-white">Logout</div>
            </div>
          </div>
          {/* {children} */}
        </div>
      </div>
    </div>
  );
};
